var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-progress-bar`, `${_vm.$appPrefix}-progress-bar--${_vm.theme}`]},[_c('div',{class:[`${_vm.$appPrefix}-progress-bar__move`, {[`${_vm.$appPrefix}-progress-bar__move--under-50`]: _vm.value < 50}],style:({width: _vm.value + '%'})},[_c('strong',[_vm._v(_vm._s(_vm.value)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }